import * as React from "react";

import { Colors, RainBow } from "../../../../design-tokens/colors";
import { grid } from "../../../../design-tokens/grid";
import { Device } from "../../../../design-tokens/media-queries";

const items = [
  {
    name: "Government response Index (All)",
    color: "#FF9C07",
  },
  {
    name: "Containment health Index (C, H)",
    color: Colors.Red,
  },
  {
    name: "Stringency Index (C, H1)",
    color: RainBow.GrassGreen,
  },
  {
    name: "Economic support Index (E)",
    color: RainBow.SkyBlue,
  },
];

const ResponseSeriesLegends: React.FC = () => {
  return (
    <div
      css={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        fontSize: "14px",
        marginBottom: grid(1),

        [Device.Mobile]: {
          display: "none",
        },
      }}
    >
      {items.map((i) => (
        <div
          key={i.name}
          css={{
            display: "flex",
            alignItems: "center",
            marginRight: grid(1),
            whiteSpace: "nowrap",
          }}
        >
          <span
            css={{
              display: "block",
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: i.color,
              marginRight: grid(0.5),
            }}
          />
          {i.name}
        </div>
      ))}
    </div>
  );
};

export default ResponseSeriesLegends;
